<ng-template let-extraClass="extraClass" #topNav>
  @if (!windowService?.isDesktopRes) {
    <tidy-top-nav
      [class]="extraClass"
      [title]="'Connect Bank'"
      [canGoBack]="true"
      [customBack]="fromGettingStarted ? 'getting-started' : null" />
  }
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <tidy-wrapper>
    @if (!loaded) {
      <div class="loading-container">
        <tidy-loader />
      </div>
    }
    @if (loaded) {
      <tidy-card>
        <div class="bank-feature-row">
          <div class="bank-feature-icon">
            <tidy-image
              [src]="'assets/svg/sync-outline.svg'"
              class="header-size" />
          </div>
          <div class="bank-feature-text">
            <tidy-text [header]="'Automatic AI Reconciliation'" />
            <tidy-text [body]="'TIDY\'s AI automatically reconciles every transaction to the right property and category — no manual entry.'" />
          </div>
        </div>
      </tidy-card>

      <tidy-card>
        <div class="bank-feature-row">
          <div class="bank-feature-icon">
            <tidy-image
              [src]="'assets/svg/cash-outline.svg'"
              class="header-size" />
          </div>
          <div class="bank-feature-text">
            <tidy-text [header]="'Track Income & Expenses'" />
            <tidy-text [body]="'See all property income and expenses in one place.'" />
          </div>
        </div>
      </tidy-card>

      <tidy-card>
        <div class="bank-feature-row">
          <div class="bank-feature-icon">
            <tidy-image
              [src]="'assets/svg/wallet-outline.svg'"
              class="header-size" />
          </div>
          <div class="bank-feature-text">
            <tidy-text [header]="'Multi-Account Support'" />
            <tidy-text [body]="'Connect multiple bank accounts for a unified financial view.'" />
          </div>
        </div>
      </tidy-card>

      <tidy-card>
        <div class="bank-feature-row">
          <div class="bank-feature-icon">
            <tidy-image
              [src]="'assets/svg/eye-outline.svg'"
              class="header-size" />
          </div>
          <div class="bank-feature-text">
            <tidy-text [header]="'Read-Only Access'" />
            <tidy-text [body]="'Connections are strictly read-only. We can\'t access, control, or withdraw funds from your account.'" />
          </div>
        </div>
      </tidy-card>

      <tidy-card>
        <div class="bank-feature-row">
          <div class="bank-feature-icon">
            <tidy-image
              [src]="'assets/svg/shield-checkmark-outline.svg'"
              class="header-size" />
          </div>
          <div class="bank-feature-text">
            <tidy-text [header]="'Bank-Level Encryption'" />
            <tidy-text [body]="'Your data is fully encrypted with bank-level security, powered by Stripe, and never shared with unauthorized parties.'" />
          </div>
        </div>
      </tidy-card>

      @if (connectedAccounts.length > 0) {
        <tidy-card>
          <tidy-row>
            <tidy-text [header]="'Connected Accounts'" />
          </tidy-row>
          @for (account of connectedAccounts; track account.id) {
            <tidy-row>
              <tidy-text [body]="account.institution_name + ' ····' + account.last4" />
            </tidy-row>
          }
        </tidy-card>
      }

      @if (connectedAccounts.length === 0) {
        <tidy-row class="align-right">
          @if (!fromGettingStarted) {
            <tidy-button
              [text]="'Skip'"
              [action]="skipStep"
              class="secondary" />
          }
          <tidy-button
            [text]="isConnecting ? 'Connecting...' : 'Connect Bank'"
            [action]="connectBank"
            class="primary"
            [disabled]="isConnecting" />
        </tidy-row>
      }

      @if (connectedAccounts.length > 0) {
        <tidy-button
          [text]="'Complete Step'"
          [action]="completeStep"
          class="primary" />
      }
    }
  </tidy-wrapper>
</ng-template>

@if (!windowService?.isDesktopRes) {
  <app-scroll-wrapper [templateContent]="content" />
} @else {
  <ng-container *ngTemplateOutlet="content" />
}
